// Vendor imports
const _ = require('lodash')
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { ARTICLE_IS_MIXED_CHANGE_PENDING } = require('client-v2/common/models/article/actions')
const tag = require('client-v2/common/utils/hyperscript')
const ArticleMixButton = require('client-v2/common/containers/lightweight-engagement/components/article-mix-button')

const bem = BemEntity('ContentAddModalUrlForm')

class ContentAddModalUrlForm extends React.PureComponent {
  constructor(props) {
    super(props)

    this.urlTextareaRef = React.createRef()

    this.onUrlTextChange = this.onUrlTextChange.bind(this)
    this.onUrlSubmit = this.onUrlSubmit.bind(this)
    this.fetchArticle = _.debounce(this.props.fetchArticle, 1000)
  }

  componentDidMount() {
    if (this.props.url) {
      const textareaEl = this.urlTextareaRef.current
      textareaEl.value = this.props.url
      this.props.onUrlTextChange(textareaEl.value)
    }
  }

  // Event Listeners

  onUrlSubmit(event) {
    event.preventDefault()
    const textareaEl = this.urlTextareaRef.current
    this.props.onUrlSubmit(textareaEl.value)
  }

  onUrlTextChange() {
    const textareaEl = this.urlTextareaRef.current
    this.props.onUrlTextChange(textareaEl.value)
    this.fetchArticle()
  }

  // Render method

  render() {
    return (
      tag('div', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        tag('div', {
          className: bem.element('header')
        },
          'Add a post to Mix'
        ),
        tag('div', {
          className: bem.element('subheader')
        },
          'Mix any website, article, or video by pasting the link below.'
        ),
        tag('form', {
          className: bem.element('url-form'),
          onSubmit: this.onCreateClick
        },
          tag('input', {
            ref: this.urlTextareaRef,
            className: bem.element('url-input'),
            autoComplete: 'off',
            autoCorrect: 'off',
            autoCapitalize: 'off',
            autoFocus: true,
            placeholder: 'Paste your link here',
            spellCheck: 'false',
            tabIndex: 1,
            type: 'text',
            onChange: this.onUrlTextChange
          }),
          tag(ArticleMixButton, {
            className: bem.element('add-button'),
            checked: this.props.isSubmitPending,
            onClick: this.onUrlSubmit
          })
        ),
        this.props.isUrlInvalid && tag('div', {
          className: bem.element('error-message')
        },
          'Sorry, that looks like an invalid URL.'
        )
      )
    )
  }
}


if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  ContentAddModalUrlForm.propTypes = {
    // Flags
    isUrlInvalid: PropTypes.bool,
    isSubmitPending: PropTypes.oneOf([
      true,
      false,
      ARTICLE_IS_MIXED_CHANGE_PENDING
    ]),
    // Values
    className: PropTypes.string,
    url: PropTypes.string,
    // Callbackss
    fetchArticle: PropTypes.func,
    onUrlSubmit: PropTypes.func,
    onUrlTextChange: PropTypes.func
  }
}

module.exports = ContentAddModalUrlForm
